import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SleepVisualization from './SleepVisualization';

class SleepVisualizationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.selectPreviousFourWeeks = this.selectPreviousFourWeeks.bind(this);
    this.selectNextFourWeeks = this.selectNextFourWeeks.bind(this);
    this.updateSelectedStart = this.updateSelectedStart.bind(this);

    this.state = {
      selectedEnd: moment().format(moment.HTML5_FMT.DATE)
    };
  }

  selectPreviousFourWeeks() {
    const previousSelectedStart = moment(this.state.selectedEnd).add(-4, 'weeks').format();
    this.updateSelectedStart(previousSelectedStart);
  }

  selectNextFourWeeks() {
    const nextSelectedStart = moment(this.state.selectedEnd).add(4, 'weeks').format();
    this.updateSelectedStart(nextSelectedStart);
  }

  updateSelectedStart(startDate) {
    this.setState({ selectedEnd: startDate });
  }

  render() {
    const { sleep } = this.props;
    if (sleep.length === 0) {
      return null;
    }

    return (
      <SleepVisualization
        selectPreviousFourWeeks={this.selectPreviousFourWeeks}
        selectNextFourWeeks={this.selectNextFourWeeks}
        selectedEnd={this.state.selectedEnd} />
    );
  }
}

SleepVisualizationContainer.propTypes = {
  sleep: PropTypes.arrayOf(PropTypes.shape)
};

export default SleepVisualizationContainer;
